import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as o, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconBook",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.25.5H10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3.25A1.75 1.75 0 0 1 1.5 9.75v-7.5A1.75 1.75 0 0 1 3.25.5Zm-.53 1.22a.75.75 0 0 1 .53-.22H9.5V8H3.25a1.75 1.75 0 0 0-.75.169V2.25a.75.75 0 0 1 .22-.53ZM2.5 9.75a.75.75 0 0 0 .75.75H9.5V9H3.25a.75.75 0 0 0-.75.75Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(e, f, i, p, h, a) {
  return o(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--book"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Book",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const g = /* @__PURE__ */ l(s, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=book.js.map
